<template>
    <button @click="reset()" type="button" class="btn text-uppercase btn-sm btn-success btn-block">
        <li class="fa fa-bolt"></li> Habilitar ALERTA DE VIBRAÇÃO
    </button>
</template>
<script>
import {Comandos, Concox} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        name: 'HabilitarAlertaVibracao',
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.habiliarAlertaVibracao(this.id_rastreador, true);
                Bus.$emit('comandos');
            }
        }
    }
</script>
